import { useEntityPage } from "../useEntityPage";
import { automationScheduleModeOptions } from "./automationTypeOptions";
import { isFixtureMode } from "./automationRules";

/** A saved automation's schedule type as text, with what it means beneath it. */
export function AutomationScheduleSummary() {
  const { record } = useEntityPage();
  // Older records hold "FixedTime" and "FixtureRelative" for these two modes.
  const mode = isFixtureMode(record?.schedulemode) ? "Fixture" : "Daily";
  const schedule = automationScheduleModeOptions.find((option) => option.value === mode);

  return (
    <div>
      <p className="fw-semibold mb-1">{schedule?.label ?? "--"}</p>
      {schedule && (
        <p className="small text-body-secondary mb-0">{schedule.description}</p>
      )}
    </div>
  );
}

export default AutomationScheduleSummary;
